import { render, staticRenderFns } from "./ProductConfirmation.vue?vue&type=template&id=5902c168&scoped=true&"
import script from "./ProductConfirmation.vue?vue&type=script&lang=js&"
export * from "./ProductConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ProductConfirmation.vue?vue&type=style&index=0&id=5902c168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5902c168",
  null
  
)

export default component.exports